import { render, staticRenderFns } from "./ResumoHabilitacaoCasamento.vue?vue&type=template&id=4adda71a&"
import script from "./ResumoHabilitacaoCasamento.vue?vue&type=script&lang=js&"
export * from "./ResumoHabilitacaoCasamento.vue?vue&type=script&lang=js&"
import style0 from "./ResumoHabilitacaoCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports